import React from "react";
import Tooltip from "views/pages/manage/common/customTooltip/CustomTooltip";
import moment from "moment";
import RadioButton from "./SelectionRationBtn";
import styles from "../transfer.module.css";
import ViewTransferHistory from "./showTransferHistory";
import {
  CourseDetailsPopupById,
  EyeIcon,
} from "views/pages/manage/unAssigned/studentCharges/common";

const progActionMap = {
  APPL: "Application",
  BTCG: "Batch Change",
  CRCG: "Course Change",
  DISC: "Discontinuation",
  FOLO: "Discontinuation with Follow up",
  IBTR: "Inter-Branch Transfer",
  MATR: "Matriculation",
  RADM: "Readmit",
};

export const getColumnList = (
  onStudentSelection,
  selectedStudentApplicationId,
  buMap,
  navigateToGivenPath
) => [
  {
    field: "psid",
    headerName: "PSID",
    sortable: true,
    width: "131px",
    render: (row) => (
      <div className="d-flex align-item-center mr-2">
        <RadioButton
          currentId={row?.applicationId}
          selectedId={selectedStudentApplicationId}
          row={row}
          onStudentSelection={onStudentSelection}
        />

        <div
          onClick={() =>
            navigateToGivenPath(`admin/edp/studentDetails/${row?.psid}`)
          }
          style={{ color: "#00B0F5", cursor: "pointer" }}
        >
          {row?.psid}
        </div>
      </div>
    ),
  },
  {
    field: "studentName",
    width: "125px",
    headerName: "Student name",
    sortable: true,
    render: (row) => (
      <div className="ellipsis-text-container">{row?.studentName}</div>
    ),
  },
  {
    field: "applicationId",
    width: "110px",
    headerName: "Application ID.",
    sortable: false,
    render: (row) => (
      <div className="ellipsis-text-container">{row?.applicationId}</div>
    ),
  },
  {
    field: "bu",
    headerName: "BU",
    width: "90px",
    sortable: false,
    render: (row) => {
      const buKey = row?.businessAreaDispVal;
      const buDesc = buMap[buKey] || "N/A";
      return (
        <div className="d-flex gap-xs align-items-center">
          <div className="ellipsis-text-container">{buKey}</div>
          <Tooltip showOnClick={true} title={buDesc}>
            <div>
              <div>
                <EyeIcon />
              </div>
            </div>
          </Tooltip>
        </div>
      );
    },
  },
  {
    field: "courseId",
    headerName: "Course ID",
    width: "70px",
    sortable: false,
    render: (row) => (
      <div className="d-flex align-items-center gap-xs">
        <div className="ellipsis-text-container">{row?.courseId}</div>
        <CourseDetailsPopupById courseId={row?.courseId} cta={<EyeIcon />} />
      </div>
    ),
  },
  {
    field: "stream",
    headerName: "Stream",
    sortable: false,
    width: "60px",
    render: (row) => (
      <div className="ellipsis-text-container">
        {row?.academicGroupDispValue}
      </div>
    ),
  },
  {
    field: "term",
    headerName: "Term",
    sortable: false,
    width: "70px",
    render: (row) => (
      <div className="ellipsis-text-container">{row?.termDispVal}</div>
    ),
  },
  {
    field: "career",
    headerName: "Career",
    sortable: false,
    width: "65px",

    render: (row) => (
      <div className="ellipsis-text-container">{row?.academicCareerValue}</div>
    ),
  },
  {
    field: "transferApplicationId",
    headerName: "Enroll.Type",
    sortable: true,
    width: "110px",

    render: (row) => (
      <div className="ellipsis-text-container">
        {row?.transferApplicationId ? "TRIN" : "FRESH"}
      </div>
    ),
  },
  {
    field: "programAction",
    headerName: "Prog. Action",
    sortable: true,
    width: "110px",
    render: (row) => {
      const value = row?.programAction;
      const desc = progActionMap[value] || "N/A";
      return (
        <div className="d-flex align-items-center ellipsis-text-container gap-xs">
          <span className="mr-2">{value}</span>
          <Tooltip showOnClick={true} title={desc}>
            <div>
              <EyeIcon />
            </div>
          </Tooltip>
        </div>
      );
    },
  },
  {
    field: "registrationDate",
    width: "123px",
    headerName: "Registration date",
    sortable: false,
    render: (row) =>
      row?.registrationDate ? (
        <Tooltip title={row?.registrationDate}>
          <div className="ellipsis-text-container">
            {moment(row?.registrationDate).format("DD-MM-YYYY")}
          </div>
        </Tooltip>
      ) : (
        <div>-</div>
      ),
  },
  {
    field: "transferType",
    headerName: "Transfer history",
    sortable: false,
    width: "120px",
    render: (row) => (
      <div className="ellipsis-text-container">
        <ViewTransferHistory psid={row?.psid} />
      </div>
    ),
  },
];
